import React, { useState } from "react";
import { TwitterPicker } from "react-color";
import { useSelector, useDispatch } from "react-redux";
import constants from "common/constants";
import { shouldFontColorBeLight } from "utils/colors";
import Icon from "components/Icon/Icon";
import TimePicker from "rc-time-picker";
import moment from "moment";

export default function GroupControlPanel({
  onEditClick,
  onColorChange,
  onTimeChange,
  color,
  group,
  attributes,
  listeners,
  setActivatorNodeRef,
  isDragging,
  isDroppable,
  isDraggingHabit,
}) {
  const [displayColorPicker, setDisplayColorPicker] = useState(false);
  const isControlPanelVisible = useSelector(
    (state) => state.controlPanel.isVisible
  );
  const dispatch = useDispatch();
  const groupColor = group.color || "green";
  const [showTimePicker, setShowTimePicker] = useState(false);
  const [timeValue, setTimeValue] = useState(
    group.time ? moment(group.time, "HH:mm").format("HH:mm") : "--"
  );

  const getIconColor = (bgColor) => {
    return shouldFontColorBeLight(bgColor)
      ? scales[groupColor][0]
      : scales[groupColor][scales[groupColor].length - 2];
  };

  const scales = constants.scales;

  function handleColorClick() {
    setDisplayColorPicker(!displayColorPicker);
  }

  function handleClose() {
    setDisplayColorPicker(false);
  }

  function handleChange(color) {
    onColorChange(color);
    setDisplayColorPicker(false);
  }

  const colors = [
    "#249c03",
    "#249cFF",
    "#ffa503",
    "#ff0000",
    "#a64ca6",
    "#888888",
    "#329999",
  ];

  const handleTimeChange = (momentObj) => {
    const newTime =
      momentObj && momentObj.isValid() ? momentObj.format("HH:mm") : "--";

    // Check if minutes are different than current
    const currentMinutes =
      timeValue !== "--" ? moment(timeValue, "HH:mm").minutes() : null;
    const newMinutes =
      momentObj && momentObj.isValid() ? momentObj.minutes() : null;

    if (
      currentMinutes !== null &&
      newMinutes !== null &&
      currentMinutes !== newMinutes
    ) {
      setTimeValue(newTime);
      setShowTimePicker(false);
      onTimeChange(newTime);
    } else {
      setTimeValue(newTime);
    }
  };

  const handleTimePickerClose = () => {
    setShowTimePicker(false);
    onTimeChange(timeValue);
  };

  const handleTimeClick = (e) => {
    e.stopPropagation();
    setShowTimePicker(!showTimePicker);
  };

  const getDatetimeValue = () => {
    return timeValue !== "--" ? moment(timeValue, "HH:mm") : null;
  };

  if (!isControlPanelVisible) return null;

  let icon = isDraggingHabit ? "Folder" : "Hamburger";

  return (
    <div className="habit-control-panel">
      <div
        className="control-block edit-block"
        onClick={onEditClick}
        style={{
          backgroundColor: scales[groupColor][4],
        }}
      >
        <Icon
          className="controlpanel-icon"
          name="Edit"
          color={getIconColor(scales[groupColor][4])}
        />
      </div>
      <div
        className="control-block color-block"
        onClick={handleColorClick}
        style={{
          backgroundColor: scales[groupColor][3],
        }}
      >
        <Icon
          className="controlpanel-icon"
          name="Circle"
          color={getIconColor(scales[groupColor][3])}
        />
        {displayColorPicker && (
          <div className="popover">
            <div className="cover" onClick={handleClose} />
            <div className="picker-wrapper">
              <TwitterPicker
                className="twitter-picker"
                colors={colors}
                onChange={handleChange}
              />
            </div>
          </div>
        )}
      </div>

      <div
        {...attributes}
        {...listeners}
        ref={setActivatorNodeRef}
        className="control-block"
        style={{
          backgroundColor: scales[groupColor][2],
        }}
      >
        <i style={{ color: getIconColor(scales[groupColor][2]) }}>
          <Icon
            className="controlpanel-icon"
            name={icon}
            fill={isDroppable ? getIconColor(scales[groupColor][2]) : null}
            color={getIconColor(scales[groupColor][2])}
          />
        </i>
      </div>
      {/* <div
        className="control-block"
        style={{
          backgroundColor: scales[groupColor][1],
        }}
      >
        <Icon
          className="controlpanel-icon"
          name="Bell"
          color={getIconColor(scales[groupColor][1])}
        />
      </div> */}
      <div
        className="control-block"
        style={{
          backgroundColor: scales[groupColor][1],
        }}
      >
        {!showTimePicker && (
          <a
            className="time"
            onClick={handleTimeClick}
            style={{
              color: getIconColor(scales[groupColor][1]),
              cursor: "pointer",
            }}
          >
            {timeValue}
          </a>
        )}
        {showTimePicker && (
          <TimePicker
            style={{
              position: "relative",
            }}
            defaultValue={getDatetimeValue()}
            open={showTimePicker}
            inputIcon={undefined}
            clearIcon={undefined}
            onOpen={() => setShowTimePicker(true)}
            onClose={handleTimePickerClose}
            onChange={handleTimeChange}
            showSecond={false}
            focusOnOpen
          />
        )}
      </div>
    </div>
  );
}
